import {ref} from 'vue';
import {defineStore} from 'pinia';
import {useI18n} from "vue-i18n";

export const useAppStore = defineStore('app', () => {
  const {t: $t} = useI18n();
  const defaultSnackBarText = $t('global.saving');

  const loading = ref(false);
  const domLoading = ref(false);
  const saveOkFeedback = ref(false);
  const error = ref(false);
  const errorData = ref({});
  const expiredLogout = ref(false); //setto a true quando sto facendo logout causa sessione scaduta (errore 417) onde evitare spawn infiniti di errori
  const snackbar = ref(false);
  const snackbarText = ref(defaultSnackBarText);

  const editName = ref(''); //nome dell'entità che si sta modificando (serve per i breadcrumb)

  function showError(data = {}){
    if(data.body_key){
      data.body = $t(data.body_key);
      delete data.body_key;
    }
    errorData.value = data;
    error.value = true;
    loading.value = false;
  }

  function hideError(){
    error.value = false;
    errorData.value = {};
  }

  function showSpinner(dom = false){
    if(dom){
      domLoading.value = true;
      return;
    }
    loading.value = true;
  }

  function hideSpinner(dom = false){
    if(dom){
      domLoading.value = false;
      return;
    }
    loading.value = false;
  }

  function showSaveFeedback(){
    saveOkFeedback.value = true;
    setTimeout(() => {
      saveOkFeedback.value = false;
    }, Number(import.meta.env.VITE_FEEDBACK_SAVE_TIMEOUT));
  }

  function showSnackBar(show, text = ''){
    snackbar.value = show;
    if(text){
      snackbarText.value = text;
    }
    else{
      snackbarText.value = defaultSnackBarText;
    }
  }

  function setEditName(newName){
    editName.value = newName?.trim();
  }

  return {
    showSpinner,
    hideSpinner,
    error,
    errorData,
    showError,
    hideError,
    loading,
    saveOkFeedback,
    showSaveFeedback,
    expiredLogout,
    showSnackBar,
    snackbarText,
    snackbar,
    setEditName,
    editName
  };
});
